import { IConfirmableInjectedAction } from '../../../../interfaces';

export class InjectedPNCClinicalDate implements IConfirmableInjectedAction {
  performActionAfterConfirm = (formData, bindObj, action) => {
    // If clinic date exists, getting current step
    if (formData.data.clinicalDate) {
      // DO NOT check if original date is empty to overcome cases that, for some reason, date exists but step is still New
      const currentStepId: string = 'PNCNew';
      const params: any = { };
      params.patientId = action.rowData.subject;
      params.testId = action.rowData.WorkflowRequest.id;
      params.revisionId = action.rowData.WorkflowRequest['revisions_-1_id'];
      bindObj.worklist.workflowUtilService.performWorkFlowStep(
        currentStepId,
        false,
        params,
        'worklist',
        (stepData) => {
          if (stepData && stepData.resource) {
            // update form data with the updated workflow step
            bindObj.worklist.refreshWorklist(
              bindObj.worklist,
              { clinicalDate: formData.data.clinicalDate },
              stepData.resource.latestRevisionStatus,
              formData.data.meta,
              action.rowData.id
            );
          } else {
            bindObj.worklist.refreshWorklist(
              bindObj.worklist,
              { clinicalDate: formData.data.clinicalDate },
              action.rowData.WorkflowRequest['revisions_-1_status'],
              formData.data.meta,
              action.rowData.id
            );
          }
        }
      );
    }
    // Refresh worklist if clinicalDate was changed
    else if (
      formData.data &&
      action.rowData.clinicalDate !== formData.data.clinicalDate
    ) {
      bindObj.worklist.refreshWorklist(
        bindObj.worklist,
        { clinicalDate: formData.data.clinicalDate },
        action.rowData.WorkflowRequest['revisions_-1_status'],
        formData.data.meta,
        action.rowData.id
      );
    }
  }
}
